/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Filterarialabel2Inputs */

const id_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter pustaka`)
};

const ms_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penapis perpustakaan`)
};

const da_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteksfilter`)
};

const de_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotheksfilter`)
};

const en_us2_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Library filter`)
};

const es_es2_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro de biblioteca`)
};

const es_mx2_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro de biblioteca`)
};

const fil_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter ng library`)
};

const fr_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtre de la bibliothèque`)
};

const it_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro libreria`)
};

const hu_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Könyvtár szűrő`)
};

const nl_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotheekfilter`)
};

const no_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotekfilter`)
};

const pl_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtr biblioteki`)
};

const pt_br2_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro de biblioteca`)
};

const pt_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro da biblioteca`)
};

const ro_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtru bibliotecă`)
};

const fi_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjastosuodatin`)
};

const sv_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteksfilter`)
};

const vi_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ lọc thư viện`)
};

const tr_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kütüphane filtresi`)
};

const cs_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtr knihovny`)
};

const bg_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Филтър на библиотеката`)
};

const ru_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр библиотеки`)
};

const uk_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фільтр бібліотеки`)
};

const ar_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فلتر المكتبة`)
};

const hi_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइब्रेरी फ़िल्टर`)
};

const th_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวกรองคลังเกม`)
};

const ja_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブラリフィルター`)
};

const zh_cn2_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游戏库筛选`)
};

const zh_hant1_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊戲庫篩選`)
};

const ko_profile_library_filterarialabel2 = /** @type {(inputs: Profile_Library_Filterarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이브러리 필터`)
};

/**
* | output |
* | --- |
* | "Library filter" |
*
* @param {Profile_Library_Filterarialabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_filterarialabel2 = /** @type {((inputs?: Profile_Library_Filterarialabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Filterarialabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_filterarialabel2(inputs)
	if (locale === "ms") return ms_profile_library_filterarialabel2(inputs)
	if (locale === "da") return da_profile_library_filterarialabel2(inputs)
	if (locale === "de") return de_profile_library_filterarialabel2(inputs)
	if (locale === "en-US") return en_us2_profile_library_filterarialabel2(inputs)
	if (locale === "es-ES") return es_es2_profile_library_filterarialabel2(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_filterarialabel2(inputs)
	if (locale === "fil") return fil_profile_library_filterarialabel2(inputs)
	if (locale === "fr") return fr_profile_library_filterarialabel2(inputs)
	if (locale === "it") return it_profile_library_filterarialabel2(inputs)
	if (locale === "hu") return hu_profile_library_filterarialabel2(inputs)
	if (locale === "nl") return nl_profile_library_filterarialabel2(inputs)
	if (locale === "no") return no_profile_library_filterarialabel2(inputs)
	if (locale === "pl") return pl_profile_library_filterarialabel2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_filterarialabel2(inputs)
	if (locale === "pt") return pt_profile_library_filterarialabel2(inputs)
	if (locale === "ro") return ro_profile_library_filterarialabel2(inputs)
	if (locale === "fi") return fi_profile_library_filterarialabel2(inputs)
	if (locale === "sv") return sv_profile_library_filterarialabel2(inputs)
	if (locale === "vi") return vi_profile_library_filterarialabel2(inputs)
	if (locale === "tr") return tr_profile_library_filterarialabel2(inputs)
	if (locale === "cs") return cs_profile_library_filterarialabel2(inputs)
	if (locale === "bg") return bg_profile_library_filterarialabel2(inputs)
	if (locale === "ru") return ru_profile_library_filterarialabel2(inputs)
	if (locale === "uk") return uk_profile_library_filterarialabel2(inputs)
	if (locale === "ar") return ar_profile_library_filterarialabel2(inputs)
	if (locale === "hi") return hi_profile_library_filterarialabel2(inputs)
	if (locale === "th") return th_profile_library_filterarialabel2(inputs)
	if (locale === "ja") return ja_profile_library_filterarialabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_filterarialabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_filterarialabel2(inputs)
	return ko_profile_library_filterarialabel2(inputs)
});
export { profile_library_filterarialabel2 as "profile.library.filterAriaLabel" }